// This is a hack as we're not doing the OIDC in react
import React from 'react'
import Configuration from '../../../../utilities/service/Configuration'

interface TokenData {
  idToken: string
  accessToken: string
}

const AuthTokenContext = React.createContext<TokenData | null>(null)

export function AuthTokenProvider({ children }: React.PropsWithChildren) {
  const clientId = Configuration.value('azureClientId')
  const idTokenRegex = new RegExp(`login.windows.net-idtoken-${clientId}-`, 'g')
  const accessTokenRegex = new RegExp(`login.windows.net-accesstoken-${clientId}-`, 'g')

  const result = {
    idToken: '',
    accessToken: '',
  }

  for (const item in localStorage) {
    if (item.match(idTokenRegex)) {
      const storage = JSON.parse(localStorage.getItem(item) ?? '')
      result.idToken = storage.secret
      continue
    }
    if (item.match(accessTokenRegex)) {
      const storage = JSON.parse(localStorage.getItem(item) ?? '')
      result.accessToken = storage.secret
      continue
    }
  }
  const hasBoth = result.idToken !== '' && result.accessToken !== ''
  if (!hasBoth) {
    console.error('React <AuthTokenProvider> failed to get idToken and accessToken from local storage')
  }

  return <AuthTokenContext.Provider value={hasBoth ? result : null}>{children}</AuthTokenContext.Provider>
}

export function useAuthToken(): TokenData {
  const context = React.useContext(AuthTokenContext)
  if (context === null) {
    throw new Error('useAuthToken must be used within a AuthTokenProvider')
  }
  return context
}
